/* global dataLayer */
import React, { useContext } from 'react';
import Currency from 'react-currency-formatter';
import PropTypes from 'prop-types';
import { sendDataToExternalBasketOne, submitAjaxToBrw } from '../../store/actions/basket';
import { connect } from 'react-redux';
import { GAContext } from 'contexts/GAContext';

const BuyAccessoriesPopup = ({
  item,
  index,
  sendDataToExternalBasketOne,
  submitAjaxToBrw,
  value,
  setValue,
}) => {
  let width = item.real_dims.width ? `szer: ${item.real_dims['width']}/` : '';
  let length = item.real_dims.length ? `dł: ${item.real_dims['length']}/` : '';
  let height = item.real_dims.height ? `wys: ${item.real_dims['height']}/` : '';
  let depth = item.real_dims.depth ? `gł: ${item.real_dims['depth']}` : '';
  let diameter = item.real_dims.diameter ? `śr: ${item.real_dims['diameter']}` : '';
  const { GA } = useContext(GAContext);

  const closePopup = name => {
    const popup = document.querySelector(`[data-popup-name="buy-accessories-popup-${name}"]`);
    if (!!popup) {
      popup.classList.remove('open');
    }
  };

  const openPopup = (name, item) => {
    closePopup(item);
    const popup = document.querySelector(`[data-popup-name="${name}"]`);
    if (!!popup) {
      popup.classList.add('open');
    }
  };

  const submitItemToBrw = item => {
    try {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          // currencyCode: 'PLN',
          add: {
            // 'add' actionFieldObject measures.
            products: [
              {
                //  adding a product to a shopping cart.
                name: item.name,
                id: item.safo,
                price: item.price.actual,
                // brand: 'Google',
                // category: 'Apparel',
                variant: item.side,
                quantity: 1,
              },
            ],
          },
        },
      });
      sendDataToExternalBasketOne(item.safo, value, 2).then(response => {
        submitAjaxToBrw(response.data.result.order).then(response => {
          // 1 - jeśli jest wszystko OK
          if (response.data.status === 1) {
            closePopup();
            openPopup('show-basket', item.safo);
          }
        });
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('submitItemToBrw', e);
    }
    GA('Buy Accessories', 'Add to Cart');
  };

  return (
    <>
      <div className="buy-accessories__popup">
        <ul className="buy-accessories__list">
          <li className="buy-accessories__list-item" key={item.name + index}>
            <img className="buy-accessories__list-img" src={item.icon} alt={item.name} />
            <p className="buy-accessories__list-text">{item.name}</p>
            <p className="buy-accessories__list-text">
              <span className="buy-accessories__list-pricing buy-accessories__list-pricing--price">
                <Currency quantity={item.price.actual * value} currency="PLN" />
              </span>
              {item.price.actual < item.price.regular && (
                <span className="buy-accessories__list-pricing buy-accessories__list-pricing--del">
                  <del>
                    <Currency quantity={item.price.regular} currency="PLN" />
                  </del>
                </span>
              )}
            </p>
            <p className="buy-accessories__list-properties">
              {`${width}${length}${height}${depth}${diameter}`}
            </p>
          </li>
        </ul>
        <div className="buy-accessories__popup-counter">
          <button
            className="buy-accessories__counter-button"
            onClick={value <= 1 ? null : () => setValue(value - 1)}>
            -
          </button>
          <p className="buy-accessories__popup-text">{value}</p>
          <button className="buy-accessories__counter-button" onClick={() => setValue(value + 1)}>
            +
          </button>
          <p className="buy-accessories__list-text">sztuk</p>
        </div>
      </div>
      <div className="buy-accessories__popup-buttons">
        <button className="buy-accessories__popup-button" onClick={() => closePopup(item.safo)}>
          ANULUJ
        </button>
        <button className="buy-accessories__popup-button" onClick={() => submitItemToBrw(item)}>
          DODAJ DO KOSZYKA
        </button>
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {
    token: state.token.token,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    sendDataToExternalBasketOne: (item, value, mode) => {
      return dispatch(sendDataToExternalBasketOne(item, value, mode));
    },
    submitAjaxToBrw: payload => {
      return dispatch(submitAjaxToBrw(payload));
    },
  };
};

BuyAccessoriesPopup.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number,
  value: PropTypes.number,
  setValue: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(BuyAccessoriesPopup);
